/* src/app/shared/components/campus-contact-editor/campus-contact-editor.component.scss */
button {
  border-radius: 22px;
  width: 120px;
}
mat-form-field {
  margin-left: 2% px;
}
.edit-form {
  width: 500px;
  text-align: center;
  margin: 0 auto 0 auto;
}
.edit-form .update-heading h3 span {
  font-weight: normal;
}
.edit-form .form-buttons {
  margin-left: 15px;
  padding-top: 15px;
}
.edit-form .form-buttons .mat-mdc-button {
  margin-right: 36px;
}
.action-buttons button {
  margin-left: 10px;
}
.certificate-datepicker {
  width: 180px;
}
.districtPortalDate {
  font-size: 12px;
}
.warningMessage {
  font-size: 12px;
  margin-bottom: 10px;
  color: red;
}
.busy-spinner {
  text-align: center;
  margin: 0 auto;
}
.mentor-documents {
  margin-top: 10px;
}
.proof-of-accomplishment-grid {
  margin-top: 5px;
}
.divider {
  border-top: 1px solid whitesmoke;
  margin: 20px 50px 20px 50px;
}
.download-dropdown-no-disallowed {
  color: #b62a39;
  font-size: 75%;
}
.district-training-grid {
  margin-top: 10px;
}
.voe-contact-checkbox {
  width: 100%;
  text-align: left;
  align-items: center;
}
.district-access-container {
  display: flex;
  justify-content: center;
}
.district-access-container .district-access-fieldset {
  border: 1px solid rgba(0, 0, 0, 0.38);
  border-radius: 4px;
  padding: 15px 12px 8px;
  width: fit-content;
}
.district-access-container .district-access-fieldset legend {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  padding: 0 4px;
}
/*# sourceMappingURL=campus-contact-editor.component.css.map */
